import { render } from "./ProvidersHomeView.vue?vue&type=template&id=19a73ad3&scoped=true"
import script from "./ProvidersHomeView.vue?vue&type=script&lang=js"
export * from "./ProvidersHomeView.vue?vue&type=script&lang=js"

import "./ProvidersHomeView.vue?vue&type=style&index=0&id=19a73ad3&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\klegrand-ext\\Documents\\intratoneinfov4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19a73ad3"]])

export default __exports__